import { Tooltip } from "@mui/material";
import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Button, ButtonGroup, TextLinkCaret } from "@vds/buttons";
import { Icon } from "@vds/icons";
import { Loader } from "@vds/loaders";
import { Modal, ModalBody } from "@vds/modals";
import { Notification } from "@vds/notifications";
import { Body, Title } from "@vds/typography";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createSearchParams,
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { fetchAllCameraAndFovsForRbac } from "../../api/DeviceServiceManager";
import { ReactComponent as Info } from "../../assets/info.svg";
import {
  BackAndNextButtonsContainer,
  ContainerWithButtons,
  FrameForDataContainer,
  ProgressBarContainer,
  ProgressSection,
  SaveAndCancelButtons,
  SectionText,
  TitleContainer,
  TitleOfContent,
  TopBar,
} from "../../global/components/OnboardingFormStyles/Styles";
import {
  findImageForList,
  getResourceIdentifierForDevice,
  getSiteInfoFromFloor,
  isDuplicateCamName,
} from "../../global/utility/Utils";
import {
  applyDevice,
  applyFieldofView,
  fetchCompanionListByCamera,
  pairCamera,
} from "../../model/cameraonboardingService";
import { createTagIfNotExists } from "../../model/reportService";
import {
  addNewArea,
  getFovNames,
  getSiteSelected,
  resetOnboardingCamera,
  setAllTagList,
  setAreaSelected,
  setCamBlurValue,
  setCamDetails,
  setCameraName,
  setCompanionList,
  setFloorSelected,
  setSelecedCompanion,
  setSelectedCamQR,
  setUnpairedCamDetails,
  showNotificationBanner,
  updateDevices,
} from "../../store/actions";
import AssignAreaandName from "./AssignAreaandName";
import { CAMERA_ONBOARDING_TEST_IDS } from "./cameraOnboardingConstants";
import NameStream from "./NameStream";
import NameStream2 from "./NameStream2";
import ReviewPage from "./ReviewPage";
import ReviewPage2 from "./ReviewPage2";
import SelectCompanion from "./selectCompanion";
import StreamCalibration from "./StreamCalibration";

//export const FormContext = createContext();

const CameraOnboarding = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const associatedCompanionId = state?.compName;
  const companionDevices = state?.companionDeviceList;
  const {
    companionSelected,
    camDetails,
    floorSelected,
    areaSelected,
    // snapshots,
    fovNames,
    blurValues,
    cameraName,
    selectedCameraQR,
    cameraBlurValue,
    subAreaSelected,
    unpairedCamDetails,
  } = useSelector((state) => state.cameraonboardingReducer);
  const fieldOfViews =
    useSelector((state) => state.cameraonboardingReducer.fovNames) || [];
  console.log({ fieldOfViews });
  const FOVIds = fieldOfViews?.map((item) => item.fovId);
  // const FOVIds = useSelector(
  //   (state) => state.cameraonboardingReducer.snapshots.id
  // );
  const { cameraList, fovList, companionDeviceList, discoveredCamerasList } =
    useSelector((state) => state?.deviceReducer);
  const { unpairedImages } = useSelector((state) => state.imagesReducer);
  const companionDevicesList = JSON.parse(
    sessionStorage.getItem("companionDevicesList")
  );

  const [isImageDownloadFailed, setIsImageDownloadFailed] = useState(false);
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [camResourceIdf, setCamResourceIdf] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [fovData, setFovData] = useState([]);
  const [showNotify, setShowNotify] = useState({
    show: false,
    type: "",
    message: "",
  });
  const breadcrumbItem = state?.breadcrumbItem;
  const editFlow = state?.editFlow ? state?.editFlow : false;
  const selCamId = !camDetails?.isPairing
    ? camDetails?.camDetails?.id
    : selectedCameraQR;

  const [showStreamCalibration, setShowStreamCalibration] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [camPosition, setCamPosition] = useState({ top: 0, left: 0 });
  const siteTagList = useSelector((state) => state.sitesReducer.siteTagList);
  const [isNextDisabled, setIsNextDisabled] = useState(false);
  const [isCreatingNewArea, setIsCreatingNewArea] = useState(false);
  const [newAreaName, setNewAreaName] = useState("");
  const [isNewAreaValid, setIsNewAreaValid] = useState(false);
  const [newAreaTagInfo, setNewAreaTagInfo] = useState("");
  const [showRetryModal, setShowRetryModal] = useState(false);

  const siteInfo = getSiteInfoFromFloor(floorSelected?.id, siteTagList);
  const tagIds = [];
  const isValidData = (data) => data && data !== "NA";
  isValidData(siteInfo?.id) && tagIds.push(siteInfo?.id);
  isValidData(floorSelected?.id) && tagIds.push(floorSelected?.id);
  isValidData(areaSelected?.id) && tagIds.push(areaSelected?.id);

  const tagIdList = useSelector((state) => {
    return state.sitesReducer.tagIdList;
  });

  // initialize camera info to redux store
  useEffect(() => {
    const selCamQR = state?.camDetails?.qrcode ?? state?.camName;
    const selCamName = state?.camDetails?.name;
    const selsiteName = state?.camDetails?.customdata?.location?.site?.name;
    const selsiteId = state?.camDetails?.customdata?.location?.site?.tag;
    const selFloorId = state?.camDetails?.customdata?.location?.floor?.tag;
    const selFloorName = state?.camDetails?.customdata?.location?.floor?.name;
    const parentdeviceid = state?.camDetails?.parentdeviceid;
    const selCompanion = companionDeviceList?.find(
      (item) => item.id === parentdeviceid
    );
    const selAreaId = state?.camDetails?.customdata?.location?.area?.tag;
    const selSubAreaId = state?.camDetails?.customdata?.location?.subarea?.tag;
    const selAreaName = state?.camDetails?.customdata?.location?.area?.name;
    const selSubAreaName =
      state?.camDetails?.customdata?.location?.subarea?.name;
    const defaultBlur = state?.camDetails?.customdata?.location?.blurConfig;
    const pairingFlow = state?.camDetails?.isPairing || state?.isPairing;

    const selectedItem = discoveredCamerasList?.find((item) => {
      return state?.isPairing
        ? item?.qrcode === selCamQR
        : state?.camDetails?.qrcode === item?.qrcode &&
            state?.camDetails?.parentdeviceid === item?.discoveredby;
    });
    const selectedItemFovIds = [],
      selectedItemFovImages = [],
      selectedItemFovNames = [];

    selectedItem?.fovs?.forEach((itemFov) => {
      selectedItemFovIds.push(itemFov.fovID);
      selectedItemFovImages.push(
        findImageForList(unpairedImages, itemFov.fovID)
      );
      selectedItemFovNames.push({
        fovName: itemFov.fovName,
        fovId: itemFov.fovID,
      });
      selectedItemFovImages.push("");
    });

    const fovItems =
      fovList?.filter(
        (item) => item.parentdeviceid === state?.camDetails?.id
      ) || [];

    const defaultFOVNames = pairingFlow
      ? selectedItemFovNames
      : fovItems?.map((item) => {
          return { fovName: item.name, fovId: item.id };
        });

    let companionList = [];
    if (selCompanion && selCompanion?.id) {
      companionList.push({ id: selCompanion?.id, name: selCompanion?.name });
      dispatch(setCompanionList(companionList));
    } else {
      setIsLoading(true);
      fetchCompanionListByCamera(activeSession, selCamQR)
        .then((response) => {
          response.forEach((item) => {
            companionList.push({ id: item.id, name: item.name });
          });
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          dispatch(setCompanionList(companionList));
          setIsLoading(false);
        });
    }

    dispatch(setSelectedCamQR(selCamQR));
    dispatch(setCameraName(selCamName));
    dispatch(setCamDetails(state));
    dispatch(getSiteSelected({ name: selsiteName, id: selsiteId }));
    dispatch(setFloorSelected({ name: selFloorName, id: selFloorId }));
    dispatch(
      setSelecedCompanion({
        id: selCompanion?.id,
        name: selCompanion?.name,
        qrcode: selCompanion?.qrcode,
      })
    );
    dispatch(setAreaSelected({ id: selAreaId, name: selAreaName }));
    dispatch(setCamBlurValue(defaultBlur));
    dispatch(getFovNames(defaultFOVNames));

    // if (selectedItem)
    //   dispatch(
    //     getSnapshot({ images: selectedItemFovImages, id: selectedItemFovIds })
    //   );
    if (state?.isPairing) dispatch(setUnpairedCamDetails({ qrcode: selCamQR }));
  }, [dispatch & state && companionDeviceList && fovList]);

  //Set New area field
  const updateCreatingNewArea = (isNewArea, newAreaName = "") => {
    setIsCreatingNewArea(isNewArea);
    setNewAreaName(newAreaName);
    console.log("Creating new area", isNewArea, newAreaName);
  };

  // rest previous camera onloading flow data
  useEffect(() => {
    return () => {
      dispatch(resetOnboardingCamera());
    };
  }, [dispatch]);

  useEffect(() => {
    fetchIdentifiers(cameraList, fovList);
  }, [cameraList && fovList && selectedCameraQR]);

  useEffect(() => {
    try {
      const siteInfo = getSiteInfoFromFloor(floorSelected?.id, siteTagList);
      dispatch(getSiteSelected({ name: siteInfo?.name, id: siteInfo?.id }));
    } catch (err) {
      console.log(err);
    }
  }, [floorSelected]);

  // setCamResourceIdf, setFovResourceIdf
  const fetchIdentifiers = (cameraList, fovList) => {
    let fovIdentifiers = [];
    const camDeviceInfo = cameraList?.find(
      (camera) => camera?.qrcode === selectedCameraQR
    );
    const fovItems =
      fovList?.filter((item) => item.parentdeviceid === selCamId) || [];
    if (camDeviceInfo) {
      const camResourceIdentifier =
        getResourceIdentifierForDevice(camDeviceInfo);
      setCamResourceIdf(camResourceIdentifier);
    } else if (camDetails?.isPairing) {
      setCamResourceIdf({ qrcode: selectedCameraQR });
    }

    FOVIds?.forEach((fovId) => {
      if (camDetails?.isPairing) {
        fovIdentifiers.push({ deviceid: fovId });
      } else {
        const foundDevice = fovList?.find((device) => device?.id === fovId);
        if (foundDevice) {
          const fovResourceIdentifier =
            getResourceIdentifierForDevice(foundDevice);
          fovIdentifiers.push(fovResourceIdentifier);
        }
      }
    });

    fovItems?.forEach((stream) => {
      const foundDevice = fovList?.find((device) => device?.id === stream?.id);
      if (foundDevice) {
        const fovResourceIdentifier =
          getResourceIdentifierForDevice(foundDevice);
        fovIdentifiers.push(fovResourceIdentifier);
      }
    });
    setFovData(fovIdentifiers);
  };

  const handleSkip = () => {
    setCurrentSectionIndex(3);
    setCurrentTabIndex(0);
    setCurrentPageIndex(0);
  };

  const handleGo = () => {
    setShowStreamCalibration(true);
  };

  const changeCurrentSection = (index) => {
    setCurrentSectionIndex(index);
    setCurrentTabIndex(0);
    setCurrentPageIndex(0);
  };

  const cancelButton = () => {
    if (currentStep === 0) {
      navigate(-1);
    } else {
      setCurrentStep(currentStep - 1);
    }
    //navigate("/devices");
  };

  const handleNextDisableChange = (disabled) => {
    setIsNextDisabled(disabled);
  };

  const handleImageDownloadFailure = (failed) => {
    setIsImageDownloadFailed(failed);
  };
  const sections = [
    {
      name: "Select companion & floor plan",
      tabs: [
        [
          <SelectCompanion
            title="Select companion device and floor plan"
            onImageDownloadFailed={handleImageDownloadFailure}
            FOVDatas={fovData}
            associatedCompanionId={associatedCompanionId}
            companionDevices={companionDevices}
            onDisableChange={handleNextDisableChange}
            editFlow={editFlow}
          />,
        ],
      ],
    },
    {
      name: "Place camera & assign area",
      tabs: [
        [
          <AssignAreaandName
            title="Place camera"
            setPosition={setCamPosition}
            setNewAreaInput={setIsNewAreaValid}
            updateCreatingNewArea={updateCreatingNewArea}
            editFlow={editFlow}
          />,
        ],
      ],
    },
    {
      name: "Name camera & streams",
      tabs: [
        [<NameStream title="Name camera & streams" editFlow={editFlow} />],
      ],
    },
    {
      name: "Review",
      tabs: [
        [
          <ReviewPage
            title="Review"
            handleTabChange={setCurrentSectionIndex}
            editFlow={editFlow}
          />,
          <ReviewPage2
            cameraName={camDetails?.camDetails?.cameraId}
            title=""
            cameraData={state?.camDetails}
          />,
        ],
      ],
    },
  ];

  const isReviewPage =
    sections[currentSectionIndex]?.tabs[currentTabIndex][currentPageIndex]
      ?.type === ReviewPage;
  const isReviewPage2 =
    sections[currentSectionIndex]?.tabs[currentTabIndex][currentPageIndex]
      ?.type === ReviewPage2;
  const isNameStream2 =
    sections[currentSectionIndex]?.tabs[currentTabIndex][currentPageIndex]
      ?.type === NameStream2;

  const buttonLabel = isReviewPage
    ? "Submit"
    : isReviewPage2
    ? "Continue"
    : "Next";

  const onNextHandler = async () => {
    const currentSection = sections[currentSectionIndex];
    const currentTab = currentSection?.tabs[currentTabIndex];
    const totalPages = currentTab?.length;

    if (currentPageIndex < totalPages - 1) {
      if (currentSectionIndex === 3 && state?.isPairing) {
        dispatch(setCamDetails({ ...camDetails, isPairing: false }));
        // navigate("/devices");
        setShowStreamCalibration(true);
      } else if (currentSectionIndex === 3 && !state?.isPairing) {
        navigate("/devices");
        // setShowStreamCalibration(true);
      } else {
        setCurrentPageIndex(currentPageIndex + 1);
      }
    } else {
      const totalTabs = currentSection?.tabs?.length;
      const totalSections = sections.length;
      if (newAreaTagInfo === "") {
        if (currentSectionIndex === 1 && isCreatingNewArea) {
          setIsLoading(true);
          const newAreaTag = await createTagIfNotExists(
            activeSession,
            "ts.tag.area",
            newAreaName,
            floorSelected?.id
          );
          setIsLoading(false);
          setNewAreaTagInfo(newAreaTag);
          dispatch(addNewArea(newAreaTag));
          dispatch(
            setAreaSelected({ id: newAreaTag?.id, name: newAreaTag?.name })
          );
          tagIdList.push(newAreaTag);
          dispatch(setAllTagList(tagIdList));
          setCurrentSectionIndex(currentSectionIndex + 1);
        }
        setCurrentSectionIndex(currentSectionIndex + 1);
      } else if (currentTabIndex < totalTabs - 1) {
        setCurrentTabIndex(currentTabIndex + 1);
        setCurrentPageIndex(0);
      } else if (currentSectionIndex < totalSections - 1) {
        setCurrentSectionIndex(currentSectionIndex + 1);
        setCurrentTabIndex(0);
        setCurrentPageIndex(0);
      } else if (currentSectionIndex === 2) {
        setCurrentSectionIndex(3);
        setCurrentTabIndex(0);
        setCurrentPageIndex(0);
      }
    }
  };

  const onBackHandler = () => {
    if (currentSectionIndex === 0) {
      navigate("/devices", { state: { showDiscoveredCamerasTab: true } });
    }
    if (currentPageIndex > 0) {
      setCurrentPageIndex(currentPageIndex - 1);
    } else {
      if (currentTabIndex > 0) {
        setCurrentTabIndex(currentTabIndex - 1);
        const totalPages =
          sections[currentSectionIndex]?.tabs[currentTabIndex - 1].length;
        setCurrentPageIndex(totalPages - 1);
      } else if (currentSectionIndex > 0) {
        setCurrentSectionIndex(currentSectionIndex - 1);
        const totalTabs = sections[currentSectionIndex - 1]?.tabs.length;
        setCurrentTabIndex(totalTabs - 1);
        // const totalPages = sections[currentSectionIndex - 1]?.tabs[totalTabs - 1].length;
        // setCurrentPageIndex(totalPages - 1);
      }
    }
  };

  // call the pairing api for unpaired cam
  const pairApi = async (compTagIdsList) => {
    try {
      const pairResponse = await pairCamera(
        companionSelected.qrcode,
        selectedCameraQR,
        activeSession,
        compTagIdsList
      );
      if (pairResponse) {
        if (
          pairResponse?.error &&
          pairResponse?.message !== "Pairing requested."
        ) {
          const notificationInfo = {
            type: "Camera pairing",
            priority: "critical",
            data: {
              subTitle: "Something went wrong, Please try again later.",
            },
            showNotification: true,
          };

          dispatch(showNotificationBanner(notificationInfo));
          throw new Error(pairResponse?.message);
        } else if (
          pairResponse?.status !== 200 &&
          pairResponse?.status !== 204 &&
          pairResponse?.message !== "Pairing requested."
        ) {
          const notificationInfo = {
            type: "Camera pairing",
            priority: "critical",
            data: {
              subTitle: "Something went wrong, Please try again later.",
            },
            showNotification: true,
          };
          dispatch(showNotificationBanner(notificationInfo));
        } else {
          // dispatch(fetchAllDevices());
          // fetchIdentifiers(cameraList, fovList);
          const notificationInfo = {
            type: "Camera pairing",
            priority: "success",
            data: {
              subTitle: "Camera has been paired successfully.",
            },
            showNotification: true,
          };
          dispatch(showNotificationBanner(notificationInfo));
          return true;
        }
      } else {
        const notificationInfo = {
          type: "Camera pairing",
          priority: "critical",
          data: {
            subTitle: "Something went wrong, Please try again later.",
          },
          showNotification: true,
        };
        dispatch(showNotificationBanner(notificationInfo));
        return false;
      }
    } catch (error) {
      console.log("Pair API Error");
      const notificationInfo = {
        type: "Camera pairing",
        priority: "critical",
        data: {
          subTitle: "Something went wrong, Please try again later.",
        },
        showNotification: true,
      };
      dispatch(showNotificationBanner(notificationInfo));
      return false;
    }
  };

  const handleSave = async ({ isSaveBtnClicked }, fovList) => {
    try {
      // call apply device api
      const resp = await applyDevice(
        camResourceIdf,
        cameraName,
        activeSession,
        siteInfo?.name,
        siteInfo?.id,
        floorSelected?.name,
        floorSelected?.id,
        areaSelected?.name,
        areaSelected?.id,
        subAreaSelected?.name,
        subAreaSelected?.id,
        cameraBlurValue,
        camPosition
      );

      if (resp) {
        if (resp?.error) {
          setShowRetryModal(true);
          throw new Error(resp?.message);
        } else {
          const camId = resp?.id;
          // call apply FOV api
          const applyFovResp = await Promise.all(
            fovNames.map(async (refFov) => {
              const foundDevice = fovList?.find(
                (device) => device?.id === refFov?.fovId
              );
              const resp = await applyFieldofView(
                getResourceIdentifierForDevice(foundDevice),
                refFov?.fovName,
                activeSession
              );
              if (resp && resp != "" && !resp.error) {
                return resp;
              } else {
                setShowRetryModal(true);
                return;
              }
            })
          );

          if (applyFovResp && applyFovResp != "" && isSaveBtnClicked) {
            doNotify(true, { type: "success", message: "Data saved." });
            return true;
          } else if (
            applyFovResp &&
            applyFovResp.some((i) => i !== undefined)
          ) {
            return camId;
          } else {
            return;
          }
        }
      }
    } catch (error) {
      console.log("API Save Error");
      doNotify(true, { type: "error", message: "Some error occured." });
      return false;
    }
  };

  const shouldEnableNextButton = () => {
    if (currentSectionIndex === 0 && currentTabIndex === 0) {
      return !!companionSelected.id && !!floorSelected.id;
    } else if (currentSectionIndex === 1 && currentTabIndex === 0) {
      return !!areaSelected.id || newAreaName !== "";
    } else if (currentSectionIndex === 2 && currentTabIndex === 0) {
      return (
        !!cameraName && !isDuplicateCamName(cameraList, selCamId, cameraName)
      );
    } else if (currentSectionIndex === 3 && currentTabIndex === 0) {
      //Disabled privacy policy
      return true;
    } else if (currentSectionIndex === 4 && currentTabIndex === 0) {
      return (
        !!companionSelected.id &&
        !!floorSelected.id &&
        !!areaSelected.id &&
        !!cameraName &&
        !isDuplicateCamName(cameraList, selCamId, cameraName)
      );
    }
    return true;
  };

  const saveCancelOptions = [
    {
      children: "Save",
      size: "small",
      use: "primary",
      width: "auto",
      disabled: !shouldEnableNextButton(),
      onClick: () => saveButtonAction(),
      "data-testid":  CAMERA_ONBOARDING_TEST_IDS.SAVE_BUTTON ,
    },
    {
      children: "Cancel",
      size: "small",
      use: "secondary",
      width: "auto",
      onClick: () => cancelButton(),
      "data-testid": CAMERA_ONBOARDING_TEST_IDS.CANCEL_BUTTON,
    },
  ];

  const saveButtonAction = () => {
    setIsLoading(true);
    handleSave({ isSaveBtnClicked: true }, fovList).then((resp) => {
      if (resp) setIsLoading(false);
    });
  };

  const handlePostPairApiCalls = () => {
    setShowRetryModal(false);
    fetchAllCameraAndFovsForRbac(activeSession).then((cameraAndFovDevices) => {
      dispatch(
        updateDevices({
          cameraList: cameraAndFovDevices.cameras,
          fovList: cameraAndFovDevices.fovs,
        })
      );
      handleSave({ isSaveBtnClicked: false }, cameraAndFovDevices.fovs).then(
        (resp) => {
          if (resp) {
            setIsLoading(true);
            // call sync cam position API
            onNextHandler();
          }
        }
      );
    });
  };

  const doAction = () => {
    if (buttonLabel === "Submit") {
      setIsLoading(true);
      // PAIRING - SAVE
      if (camDetails?.isPairing) {
        pairApi(tagIds).then((resp) => {
          if (resp) {
            handlePostPairApiCalls();
          }
          setIsLoading(false);
        });
      } else {
        // EDIT - SAVE
        // call handle save API
        handleSave({ isSaveBtnClicked: false }, fovList).then((resp) => {
          if (resp) {
            onNextHandler();
          }
          setIsLoading(false);
          //dispatch(fetchAllDevices());
        });
      }
    } else {
      onNextHandler();
    }
  };

  const doNotify = (showStatus, notifyDetails = {}) => {
    if (!showStatus) {
      setShowNotify({ show: false, type: "", message: "" });
    } else {
      setShowNotify({
        show: true,
        type: notifyDetails?.type,
        message: notifyDetails?.message,
      });
    }
  };

  return (
    <>
      <Modal
        opened={showRetryModal}
        disableOutsideClick={true}
        ariaLabel="Device information update failed modal"
        onHide={() => {}}
        hideCloseButton={true}
        closeButton={
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px",
            }}
          >
            <Icon name="close" />
          </div>
        }
      >
        <Title bold={true} size="medium">
          {" "}
          Camera update failed
        </Title>
        <ModalBody>
          <p className="sasp_d-flex flex-column" style={{ flexWrap: "wrap" }}>
            {" "}
            Camera pairing was successful but we failed to update it with its
            details. Please click on retry if you wish to try and update the
            details again. You can also skip to stream calibration by clicking
            the skip button.
          </p>
        </ModalBody>
        <div
          style={{
            width: "90%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: "10px",
            textAlign: "center",
          }}
        >
          <Button
            size="large"
            use="primary"
            width="45%"
            onClick={() => {
              setShowRetryModal(false);
              handlePostPairApiCalls();
            }}
            data-testid={CAMERA_ONBOARDING_TEST_IDS.RETRY_MODAL_RETRY_BUTTON}
          >
            Retry
          </Button>
          <Button
            size="large"
            use="secondary"
            width="45%"
            onClick={() => {
              setShowRetryModal(false);
              onNextHandler();
            }}
            data-testid={CAMERA_ONBOARDING_TEST_IDS.RETRY_MODAL_SKIP_BUTTON}
          >
            Skip
          </Button>
        </div>
      </Modal>

      {!showStreamCalibration ? (
        <div>
          {breadcrumbItem == "Camera Pairing" && (
            <Breadcrumbs surface="light">
              <BreadcrumbItem>
                <Link
                  data-testid="cameraOnboarding_discoveredCamerasDevicesLink"
                  to="/devices"
                  state={{ tabName: "Unpaired Cameras" }}
                  className="breadcrums-item_link"
                >
                  Discovered Cameras
                </Link>
              </BreadcrumbItem>
              <BreadcrumbItem>{breadcrumbItem}</BreadcrumbItem>
            </Breadcrumbs>
          )}

          {breadcrumbItem != "Camera Pairing" && (
            <Breadcrumbs surface="light">
              <BreadcrumbItem>
                <Link
                  data-testid="cameraOnboarding_camerasDevicesLink"
                  to="/devices"
                  state={{ tabName: "Cameras" }}
                  className="breadcrums-item_link"
                >
                  Cameras
                </Link>
              </BreadcrumbItem>
              {breadcrumbItem != "Camera Pairing" && (
                <BreadcrumbItem>
                  {" "}
                  <Link
                    data-testid="cameraOnboarding_cameraInfoPageLink"
                    to={{
                      pathname: "/cameraInfoPage",
                      search: `?${createSearchParams({
                        cameraId: state?.camDetails?.id,
                      })}`,
                    }}
                    className="breadcrums-item_link"
                  >
                    Camera Details
                  </Link>
                </BreadcrumbItem>
              )}
              <BreadcrumbItem>{breadcrumbItem}</BreadcrumbItem>
            </Breadcrumbs>
          )}
          <TitleContainer>
            <ContainerWithButtons>
              <h3
                className="sasp_vz-nhg-eds-font"
                style={{ fontWeight: "300", fontSize: "32px" }}
              >
                {state?.camDetails?.name || "camera_" + state?.camName}
                <Tooltip
                  placement="top"
                  title={
                    <div
                      style={{
                        width: "auto",
                        padding: "5px",
                        color: "black",
                        fontSize: "12px",
                      }}
                    >
                      <Body viewport="desktop" size="small" bold={true}>
                        {" "}
                        Camera Id{" "}
                      </Body>
                      <Body size="small" viewport="desktop">
                        {state?.camDetails?.qrcode || state?.camName}
                      </Body>
                    </div>
                  }
                  arrow
                  slotProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "white",
                        border: "1px solid black",
                        "& .MuiTooltip-arrow": {
                          backgroundColor: "white",
                        },
                      },
                    },
                  }}
                >
                  <sup>
                    {" "}
                    <Info />{" "}
                  </sup>
                </Tooltip>
              </h3>
              <SaveAndCancelButtons>
                <ButtonGroup
                  childWidth={"100%"}
                  viewport={"desktop"}
                  rowQuantity={{ desktop: 2 }}
                  data={
                    currentSectionIndex < sections.length - 1 &&
                    (camDetails?.isPairing
                      ? [saveCancelOptions[1]]
                      : saveCancelOptions)
                  }
                  alignment={"center"}
                />
              </SaveAndCancelButtons>
            </ContainerWithButtons>

            {showNotify?.show && (
              <Notification
                type={showNotify?.type}
                title={showNotify?.message}
                fullBleed={true}
                inline={false}
                disableFocus={true}
                onCloseButtonClick={() => {
                  doNotify(false);
                }}
                data-testid={CAMERA_ONBOARDING_TEST_IDS.NOTIFICATION_CLOSE_BUTTON}
              />
            )}

            <ProgressBarContainer>
              {sections.map((section, index) => (
                <ProgressSection
                  key={index}
                  // onClick={() => changeCurrentSection(index)}
                >
                  <TopBar
                    index={index}
                    currentSectionIndex={currentSectionIndex}
                  />
                  <SectionText
                    index={index}
                    currentSectionIndex={currentSectionIndex}
                  >
                    {index + 1}. {section.name}
                  </SectionText>
                </ProgressSection>
              ))}
            </ProgressBarContainer>

            <FrameForDataContainer
              className={`d-flex justify-content-center align-items-center w-100`}
            >
              <div className="w-50">
                <TitleOfContent>
                  {
                    sections[currentSectionIndex]?.tabs[currentTabIndex][
                      currentPageIndex
                    ]?.props?.title
                  }
                </TitleOfContent>
                <div id="content-container">
                  {
                    sections[currentSectionIndex]?.tabs[currentTabIndex][
                      currentPageIndex
                    ]
                  }
                </div>
                <BackAndNextButtonsContainer>
                  {!isReviewPage2 && !isNameStream2 && (
                    <TextLinkCaret
                      surface="light"
                      iconPosition="left"
                      // disabled={
                      //   currentSectionIndex === 0 &&
                      //   currentTabIndex === 0 &&
                      //   currentPageIndex === 0
                      // }
                      data-testid={CAMERA_ONBOARDING_TEST_IDS.BACK_BUTTON}
                      onClick={onBackHandler}
                    >
                      Back
                    </TextLinkCaret>
                  )}
                  {!isReviewPage2 && !isNameStream2 && (
                    <Button
                      size="large"
                      use="primary"
                      onClick={doAction}
                      disabled={!shouldEnableNextButton() || isNextDisabled}
                      data-testid={CAMERA_ONBOARDING_TEST_IDS.MAIN_ACTION_BUTTON}
                    >
                      {buttonLabel}
                    </Button>
                  )}
                </BackAndNextButtonsContainer>
              </div>
            </FrameForDataContainer>
          </TitleContainer>

          {isLoading && <Loader fullscreen={false} active={isLoading} />}
        </div>
      ) : (
        <StreamCalibration />
      )}
    </>
  );
};

export default CameraOnboarding;
